<template>
  <div v-if="submitFlag">
    <el-button icon="el-icon-back" type="primary" @click="submitFlag = false">返回购物车</el-button>
    <ApplySample
      class="cml-shopping-apply-sample"
      ref="sampleDialog"
      @on-success="smapleSaveSuccess"
      @submit-error="smapleSaveSuccess"
    />
  </div>
  <div class="cml-shopping-cart" v-else>
    <!-- header -->
    <el-row class="shopping-cart-header">
      <el-col :span="14">
        <el-checkbox v-model="allCheck" @change="toggle">全选</el-checkbox>
        <div class="header-text" style="padding-left: 60px;"> 
          <span>产品信息</span>
        </div>
      </el-col>
      <el-col style="padding-left: 40px" :span="5">
        <div class="header-text">数量</div>
      </el-col>
      <el-col style="margin-left: -20px" :span="5">
        <div class="header-text">操作</div>
      </el-col>
    </el-row>
   
    <!-- body -->
    <div class="shopping-cart-body">
      <p v-if="cardData.length < 1" class="empty-tips">
        您的购物车还是空的，赶紧<el-button type="text" @click="goApplyPage">添加产品</el-button>吧！
      </p>
      <div v-for="(item, index) in cardData" :key="item.id">
        <div class="shopping-cart-body__title">
          <el-checkbox
            v-model="supplyCheck[index]"
            @change="val => supplierToggle(val, index)"
          >
            {{ item.supplierName }}
            <b v-if="item.isFormal && item.isFormal === '1'" style="color: #f00;">(正在引入评估中的供应商)</b>
          </el-checkbox>
        </div>
        <div class="shopping-cart-details">
          <el-row
            class="shopping-cart-body__content"
            v-for="item_2 in item.list"
            :key="item_2.id"
          >
            <el-col :span="14" class="check-single">
              <el-checkbox v-model="item_2.isCheck"></el-checkbox>
              <el-image
                v-if="item_2.sample.type !== 'RAW_MATERIAL'"
                style="width: 50px; height: 50px; margin-right: 5px;"
                :src="item_2.sample.mainImage + $ImgQuality30"
                :preview-src-list="[item_2.sample.mainImage + $ImgPreviewQuality]"
                fit="contain"
              >
                <div slot="placeholder" class="sample-image-slot">
                  加载中
                </div>
              </el-image>
              <div class="sample-detial">
                <span>{{ item_2.sample.productName }}</span>
                <span 
                  v-if="item_2.sample.type === 'PACKING_MATERIAL' && item_2.sample.packingMaterialSampleCO.capacityUnitPriceVOList[0].capacity">
                  容量：
                  {{ item_2.sample.packingMaterialSampleCO.capacityUnitPriceVOList[0].capacity }}
                  {{ item_2.sample.packingMaterialSampleCO.capacityUnit }}
                </span>
              </div>
            </el-col>
            <el-col :span="5" class="content-col">
              <el-input-number v-model="item_2.num" :min="1" @change="numChange(item_2)"></el-input-number>
            </el-col>
            <el-col :span="5" class="content-col">
              <el-button type="text" @click="deleteBtn(item_2.id)">删除</el-button>
            </el-col>
          </el-row>
        </div>
      </div>
      <div class="enable_block" v-for="(item) in soldOutData" :key="item.id">
        <div class="shopping-cart-body__title">
          <el-checkbox disabled>{{ item.supplierName }}</el-checkbox>
        </div>
        <div class="shopping-cart-details">
          <el-row
            class="shopping-cart-body__content"
            v-for="item_2 in item.list"
            :key="item_2.id"
          >
            <el-col :span="14" class="check-single">
              <el-checkbox
                :disabled="item_2.isEnable === '0'"
                v-model="item_2.isCheck"
              ></el-checkbox>
              <img
                v-if="item_2.isEnable === '0'"
                class="xiajia-img"
                src="../../assets/images/xiajia.png"
              />
              <img
                class="sample-img"
                :src="item_2.sample.mainImage"
                v-if="item_2.sample.type !== 'RAW_MATERIAL'"
              />
              <div class="sample-detial">
                <span>{{ item_2.sample.productName }}</span>
                <span v-if="item_2.sample.type === 'PACKING_MATERIAL'">
                  容量：
                  {{ item_2.sample.packingMaterialSampleCO.capacityUnitPriceVOList[0].capacity }}
                  {{ item_2.sample.packingMaterialSampleCO.capacityUnit }}
                </span>
              </div>
            </el-col>
            <el-col :span="5" class="content-col">
              <el-input-number disabled v-model="item_2.num" :min="1" @change="numChange(item_2)"></el-input-number>
            </el-col>
            <el-col :span="5" class="content-col">
              <el-button type="text" @click="deleteBtn(item_2.id)">删除</el-button>
            </el-col>
          </el-row>
        </div>
      </div>
    </div>
    <!-- footer -->
    <div class="shopping-cart-footer">
      <div class="shopping-cart-footer__content">
        <div class="select-all-btn">
          <el-checkbox v-model="allCheck" @change="toggle"
            >全选</el-checkbox
          >
          <el-button type="text" :disabled="cartBtnDisabled" @click="deleteAllBtn">删除选中的样品</el-button>
        </div>
        <div class="submit-btn">
          <el-button type="primary" :disabled="cartBtnDisabled" @click="submitBtn">提交样品申请</el-button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import ApplySample from '@/components/ApplySample';
export default {
  components: { ApplySample },
  name: 'cml-shopping-cart',
  data: () => ({
    cardData: [],
    soldOutData: [],
    submitFlag: false,
  }),
  computed: {
    supplyCheck() {
      return this.cardData.map(item => item.list.every(e => e.isCheck));
    },
    allCheck() {
      if(this.getCheckedData().length < 1) {
        return false;
      }
      return this.supplyCheck.every(Boolean);
    },
    cartBtnDisabled() {
      return this.getCheckedData().length < 1;
    }
  },
  activated() {
    this.getShoppingCartList();
  },
  methods: {
    // 获取购物车列表
    getShoppingCartList() {
      this.$http.shoppingCart
        .getShoppingCartList()
        .then(result => {
          // 更新购物车数量
          this.$store.commit('addSampleToCart/setShoppingCartNum', result.data.length);

          // 根据供应商名称进行分类 区分上架商品和下架商品
          this.soldOutData = this.transformData(result.data.filter(item => item.isEnable === '0'), 'disabled');
          this.cardData = this.transformData(result.data.filter(item => item.isEnable === '1'), 'enable');
        })
        .catch(err => {
          this.$message.error(err.msg);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    // 购物车数据转换
    transformData(arr, status) {
      return arr.reduce((acc, cur) => {
        const index = acc.findIndex(element => {
          return (element || {}).supplierName === cur.supplierName;
        });
        // -1表示没有找到相同的supplierName 表示当前供应商只有一条数据
        const toResposeData = {
          ...cur,
          ...cur.sample,
          ...(status !== 'disabled' && { isCheck: false }),
          sampleType: cur.sample.type,  
          shoppingCartId: cur.id,
        };
        if (index === -1) {
          acc.push({
            supplierName: cur.supplierName,
            isFormal: cur.isFormal,
            list: [toResposeData]
          });
        } else {
          acc[index]['list'].push(toResposeData);
        }
        return acc;
      }, []);
    },
    // 全选按钮
    toggle(val) {
      this.cardData = this.cardData.map(item => {
        return {
          ...item,
          list: item.list.map(item_2 => {
            return {
              ...item_2,
              isCheck: val
            };
          }),
        };
      });
    },
    // 供应商全选
    supplierToggle(val, index) {
      this.cardData[index].list = this.cardData[index].list.map(item => {
        return {
          ...item,
          isCheck: val
        };
      });
    },
    // 获取选中的数据
    getCheckedData() {
      const data = this.cardData.map(item => {
        return {
          ...item,
          list: item.list.filter(e => e.isCheck).map(item => {
            // 包材需要将容量显示出来
            return {
              ...(item.type === 'PACKING_MATERIAL' && {
                ...item.sample.packingMaterialSampleCO,
                ...item.sample.packingMaterialSampleCO.capacityUnitPriceVOList[0]
              }),
              ...item
            }
          })
        };
      }).filter(item => item.list.length > 0);
      return data;
    },
    // 删除单个样品
    deleteBtn(id) {
      this.$confirm('确定要删除吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        this.$http.shoppingCart
          .deleteShoppingCart(id)
          .then(result => {
            this.$message.success(result.msg);
            this.getShoppingCartList();
          })
          .catch(err => {
            this.$message.error(err.msg);
          });
      });
    },
    submitBtn() {
      this.$http.sample.orderCanCreate().then(res => {
        if (res.data && res.data === true) {
          this.submitFlag = true;
          this.$nextTick(() => {
            this.$refs.sampleDialog.setListForm(this.getCheckedData());
          });
        } else {
          this.$message.error('存在超过30天未反馈的样品申请，请先完成样品反馈再发起寻样申请');
        }
      }).catch((err) => {
        this.$message.error(err.msg);
      })
    },
    // 删除选中的样品
    deleteAllBtn() {
      const ids = this.getCheckedData().reduce((acc, cur) => {
        return [...acc, ...cur.list.map(item => item.id)];
      }, []);
      this.$confirm('确定要删除吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        this.$http.shoppingCart.deleteShoppingCartIds(ids).then(result => {
          this.$message.success(result.msg);
          this.getShoppingCartList();
        }).catch(err => {
          this.$message.error(err.msg);
        });
      });
    },
    numChange(item) {
      this.$http.shoppingCart.updateShoppingCart({
        id: item.id,
        num: item.num
      }).then(() => {
        this.getShoppingCartList();
      }).catch(err => {
        this.$message.error(err.msg);
      });
    },
    // 提交索样申请
    smapleSaveSuccess() {
      this.submitFlag = false;
      this.getShoppingCartList();
    },
    // 寻样申请页面
    goApplyPage() {
      const pageName = '寻样申请';
      const pageUrl = `warehouse-sample-manage/sample-application`;
      this.$store.dispatch('tagsView/clearPage', '');
      this.$store.dispatch('tagsView/changeHeaderMenusList', {
        name: pageName,
        href: `/${pageUrl}`,
      });
      this.$router.push({
        name: pageUrl,
      });
    }
  },
};
</script>
<style lang="less">
.cml-shopping-cart {
  height: 100%;
  position: relative;
  color: #606266;
  font-size: 16px;
  .shopping-cart-header {
    margin: 10px 20px 0 20px;
    .header-text{
      
      display: inline;
      font-size: 14px;
      font-weight: bold;
    }
  }
  .shopping-cart-body {
    font-size: 14px;
    margin: 0 20px;
    padding-bottom: 70px;
    height: calc(100vh - 250px);
    overflow-y: auto;
    .shopping-cart-body__title {
      margin: 20px 0 10px 20px;
    }
    .shopping-cart-details {
      border: 1px solid #ddd;
      border-bottom: none;
      .shopping-cart-body__content {
        padding: 10px 10px 10px 20px;
        border-bottom: 1px solid #ddd;
        .check-single {
          height: 50px;
          display: flex;
          flex-direction: row;
          align-items: center;
          .xiajia-img{
            position: absolute;
            left: 44px;
            top: 10px;
          }
          .sample-detial{
            padding-left: 12px;
          }
          .el-checkbox {
            margin-right: 10px;
          }
        }
        .content-col{
          line-height: 50px;
        }
        .sample-img {
          width: 50px;
          height: 50px;
        }
        .sample-detial {
          display: flex;
          flex-direction: column;
          span {
            margin: 5px 0;
          }
        }
      }
    }
  }
  .shopping-cart-footer {
    width: 100%;
    position: absolute;
    bottom: 0px;
    height: 50px;
    z-index: 2000;
    .shopping-cart-footer__content {
      background: #ddd;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      margin: 0 20px;
      .select-all-btn {
        height: 50px;
        line-height: 50px;
        padding-left: 20px;
        .el-button {
          margin-left: 20px;
          font-size: 14px;
        }
      }
      .submit-btn {
        width: 200px;
        button {
          border-radius: 0;
          border: none;
          text-align: center;
          width: 200px;
          height: 50px;
          text-align: center;
          font-size: 14px;
          letter-spacing: 2px;
          cursor: pointer;
        }
      }
    }
  }
}
.cml-shopping-apply-sample {
  .product-info-right {
    min-width: 600px;
  }
}
.empty-tips {
  position: absolute;
  left: 50%;
  top: 100px;
  transform: translateX(-50%);
  span {
    font-size: 16px;
    &:hover {
      text-decoration: underline;
    }
  }
}
</style>